<template>
  <div class="inertia-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>τ = I · α | I = Σ mr²$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Comparing two objects rolling down a slope -->
          <line x1="50" y1="60" x2="350" y2="180" stroke="#888" stroke-width="4" />
          
          <!-- Object A: Solid Disk (I = 1/2 MR^2) -->
          <g :transform="`translate(${posA.x}, ${posA.y}) rotate(${rotA})`">
             <circle r="15" fill="rgba(0, 111, 253, 0.4)" stroke="#00d2ff" stroke-width="2" />
             <line x1="0" y1="0" x2="15" y2="0" stroke="#fff" />
          </g>
          <text :x="posA.x - 20" :y="posA.y - 20" fill="#00d2ff" font-size="8">圆柱体</text>

          <!-- Object B: Hollow Hoop (I = MR^2) -->
          <g :transform="`translate(${posB.x}, ${posB.y}) rotate(${rotB})`">
             <circle r="15" fill="none" stroke="#ff4757" stroke-width="4" />
             <line x1="0" y1="0" x2="15" y2="0" stroke="#fff" />
          </g>
          <text :x="posB.x - 20" :y="posB.y - 20" fill="#ff4757" font-size="8">圆环</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>相同质量与半径，分布不同</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row info-flex">
             <div class="info">Disk (A): 更快到达</div>
             <div class="info">Hoop (B): 更慢到达</div>
          </div>
          <el-button type="primary" size="mini" @click="reset">重置实验</el-button>
          <el-button size="mini" @click="running = !running">{{ running ? '暂停' : '开始' }}</el-button>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>转动惯量是转动**惯性**的量度。质量分布越偏离转轴，$I$ 越大。在坡道测试中，转动惯量大的物体需要更多能量转化为转动动能，因此**平移加速度较小**，下落较慢。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MomentOfInertiaViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      t: 0,
      running: true,
      timer: null
    }
  },
  computed: {
    posA() {
      // a = g sin theta / (1 + I/MR^2)
      // For disk, denominator is 1.5
      let dist = 1.5 * Math.pow(this.t, 2);
      return this.calcPos(dist);
    },
    posB() {
      // For hoop, denominator is 2.0
      let dist = 1.125 * Math.pow(this.t, 2); // (1.5 / 2.0) * disk's acc
      return this.calcPos(dist, 40); // Offset for view
    },
    rotA() { return this.t * 100; },
    rotB() { return this.t * 75; }
  },
  methods: {
    calcPos(s, offset = 0) {
      const maxX = 330;
      const x = Math.min(maxX, 50 + s);
      const y = 60 + (x - 50) * 0.4 - 15 - offset;
      return { x, y };
    },
    reset() { this.t = 0; },
    update() {
      if (this.running && this.t < 14) {
        this.t += 0.05;
      }
      this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.inertia-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.info-flex { display: flex; justify-content: space-around; margin-bottom: 10px; }
.info { font-size: 0.7rem; color: #888; }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
